import { Helmet } from 'react-helmet-async'
import JsonLd from '../components/JsonLd'
import { Star } from 'lucide-react'
import { useEffect, useState } from 'react'
import { clsx } from 'clsx'
import { publicUrl } from '../utils/publicUrl'

export default function MeetTheTeam() {
  const [testimonialIndex, setTestimonialIndex] = useState(0)

  // Testimonials data
  const testimonials = [
    {
      name: 'Debbie Edwards',
      title: 'Professional Assistant at Vitality Global',
      quote:
        `Hi Sharon & Mary, I want to extend my heartfelt thanks to Sharon at Indojet Travel for her outstanding service. Between October and November, we experienced an influx of international travel requests, and Sharon managed each one with remarkable ease and efficiency. Her patience, professionalism, and commitment ensured that every detail was handled perfectly, keeping my Executive, Actuarial, and Product teams happy and stress-free. Sharon's ability to remain calm under pressure, while delivering exceptional results is truly commendable. @Sharon Pretorius thank you for your outstanding support. Your hard work does not go un-noticed! Thank you for helping to make my job easier! You are a shining STAR! Have a good weekend!`,
    },
    {
      name: 'Themba Phatwa',
      title: 'On-Site Specialist – Discovery',
      quote:
        `Dear Lindi I trust you are well. I am sending this email to thank you for the service you have provided when I was doing my booking. Every time I get to interact with you, you are very professional and willing to go an extra mile. This week again you dazzle me with your service, you make sure that all was in order and follow up with a message very early morning to check is I have resubmitted my quote to make sure it is approved on time as it was an urgent booking. Keep doing what you are doing not just to me but to everyone you interact with. You are such an asset to the business.`,
    },
    {
      name: 'Linda Van Der Riet',
      title: 'PA to Johan Ebertson Discovery',
      quote:
        `My Franca, Thank you so much for always being there for me. You stopped everything you were busy with today and assisted me. I don't have words to thank you Girl!!!! You are such a treasure to me.`,
    },
    {
      name: 'Nadine Moodie',
      title: 'Executive Associate - Discovery',
      quote:
        `Hi Mary Hope you're well. Sharon Pretorius on your team has been helping me with my holiday plans for my mum and to visit Lisbon, Madrid and Barcelona in a few weeks. Sharon has been amazing to work with and has guided and advised on every step of this process. She's been extremely helpful with visas, finding accommodation options, helping with early check-in to ensure that my mum has a great seat on the plane. It's been a pleasure working with Sharon from Indo Jet.`,
    },
    {
      name: 'Dr Penelope Osiris',
      title: 'Leisure Client',
      quote:
        `Dear Sharon & Mercia, My girls and I agree that this has been our best holiday ever. Thank you so much for all you did to put it together.`,
    },
    {
      name: 'Adrian Gore',
      title: 'Group Chief Executive & Founder Discovery',
      quote:
        `Mary – I am very aware of the exemplary work – after hours – that you and your team pulled off last evening allowing our staff to get home safely – and on time for our important meetings today. We are all grateful that you went above and beyond – I just wanted you to know how much we appreciate you.`,
    },
    {
      name: 'Craig Du Preez',
      title: 'Head of Technology and Resilience Risk - Discovery',
      quote:
        `Hi Sharon, I just wanted to send a quick note to say thank you for the incredible support you've given me over the past week. You went above and beyond, even giving up your personal time over the weekend and after hours, to help with all the last-minute changes to my travel plans. Your constant updates and clear communication made such a difference, especially while I was juggling things on my end from Durban during my leave. The changes you handled on Saturday were a huge help, and when things shifted again on Monday morning, you sorted it all out so effortlessly that I didn't have to worry about a thing. I really appreciate everything you've done. Thank you again for making a stressful situation so much easier! Craig`,
    },
    {
      name: 'Michaela Kahn',
      title: 'Global Mobility Administrator – Vitality Global',
      quote:
        `Hi Winnie I just wanted to take a moment to express my heartfelt gratitude for all the incredible effort you put into assisting us with the PAH groups visit to SA and the UK. Though this note may be a little late, please know that your contributions did not go unnoticed or unappreciated. I was truly amazed by your unwavering patience throughout the entire process. Your dedication and perseverance made a huge impact on the success of their trips, and your hard work shone through – making it all possible. We are particularly grateful for your willingness to go the extra mile and the way you consistently went above and beyond the call of duty. Especially in dealing with our 11th hour requests. Once again, thank you for your remarkable efforts! Looking forward to working together again – hopefully in a less stressful and simpler manner.`,
    },
    {
      name: 'Susan Engelbrecht',
      title: 'Executive Assistant Dr Jonathan Broomberg CEO Vitality Health International',
      quote:
        `Dear Indojet team! We wanted to express our heartfelt gratitude for your constant dedication and unwavering support in assisting our VG executives with their travel arrangements. Your commitment to going the extra mile does not go unnoticed. From meticulously planning itineraries to securing the best flights and accommodations, you tirelessly ensure that our executives can navigate their business trips seamlessly. Your attention to detail and efficiency make all the difference, allowing them to focus on their work without any unnecessary travel worries. Your exceptional customer service skills have exceeded our expectations time and time again. Your prompt responses, patience, and flexibility have been invaluable in handling last-minute changes or unexpected travel complications. We are consistently impressed by your ability to find solutions and make things happen, even in challenging situations. We want you to know that your efforts do not go unnoticed or unappreciated. You play a crucial role in ensuring our executives' travel experiences are stress-free and enjoyable. Your dedication and commitment make you true superheroes in our eyes. Thank you again for all that you do. We look forward to continuing our successful partnership and witnessing your incredible superpowers in action!`,
    },
  ]

  // Auto-advance testimonials carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setTestimonialIndex((prev) => (prev + 1) % testimonials.length)
    }, 6000)
    return () => clearInterval(interval)
  }, [testimonials.length])

  return (
    <div className="bg-indojet-light min-h-screen">
      <Helmet>
        <title>Meet the Team | IndoJet Travel</title>
        <meta
          name="description"
          content="Meet the experienced team at IndoJet Travel Sandton, dedicated to delivering exceptional travel solutions for corporate and leisure clients."
        />
        <link
          rel="canonical"
          href={typeof window !== 'undefined' ? window.location.origin + '/meet-the-team' : '/meet-the-team'}
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Meet the Team | IndoJet Travel" />
        <meta
          property="og:description"
          content="Meet the experienced team at IndoJet Travel Sandton."
        />
        <meta
          property="og:url"
          content={typeof window !== 'undefined' ? window.location.href : '/meet-the-team'}
        />
        <meta property="og:image" content="/image.png" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <JsonLd
        data={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Meet the Team',
            url: typeof window !== 'undefined' ? window.location.href : '/meet-the-team',
            description:
              'Meet the experienced team at IndoJet Travel Sandton, dedicated to delivering exceptional travel solutions.',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: (typeof window !== 'undefined' ? window.location.origin : '') + '/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Meet the Team',
                item: (typeof window !== 'undefined' ? window.location.origin : '') + '/meet-the-team',
              },
            ],
          },
        ]}
      />

      {/* Team Section */}
      <div className="pt-8 sm:pt-12 pb-16 sm:pb-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="p-8 sm:p-12">
            {/* Title and Subtitle - Full Width */}
            <div className="mb-12 text-center">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-2">Our Team</h1>
              <p className="text-gray-600">
                Experienced professionals dedicated to making your travel dreams come true
              </p>
            </div>

            {/* Team Members and Photo Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              {/* Team Members List */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="space-y-1 p-4 rounded-lg hover:bg-gray-50 transition-colors">
                  <p className="font-semibold text-lg text-[#182c78]">Sharon Seskin</p>
                  <p className="text-sm text-gray-600">Chief Executive Officer (CEO)</p>
                </div>
                <div className="space-y-1 p-4 rounded-lg hover:bg-gray-50 transition-colors">
                  <p className="font-semibold text-lg text-[#182c78]">Winnie Kondowe</p>
                  <p className="text-sm text-gray-600">Travel Professional</p>
                </div>
                <div className="space-y-1 p-4 rounded-lg hover:bg-gray-50 transition-colors">
                  <p className="font-semibold text-lg text-[#182c78]">Mary Brondani</p>
                  <p className="text-sm text-gray-600">Corporate Travel Manager</p>
                </div>
                <div className="space-y-1 p-4 rounded-lg hover:bg-gray-50 transition-colors">
                  <p className="font-semibold text-lg text-[#182c78]">Sharon Pretorius</p>
                  <p className="text-sm text-gray-600">Travel Professional</p>
                </div>
                <div className="space-y-1 p-4 rounded-lg hover:bg-gray-50 transition-colors">
                  <p className="font-semibold text-lg text-[#182c78]">Candice Petherbridge</p>
                  <p className="text-sm text-gray-600">Finance Manager</p>
                </div>
                <div className="space-y-1 p-4 rounded-lg hover:bg-gray-50 transition-colors">
                  <p className="font-semibold text-lg text-[#182c78]">Lindi Van Riet</p>
                  <p className="text-sm text-gray-600">Travel Professional</p>
                </div>
                <div className="space-y-1 p-4 rounded-lg hover:bg-gray-50 transition-colors">
                  <p className="font-semibold text-lg text-[#182c78]">Tania Correia</p>
                  <p className="text-sm text-gray-600">PA to CEO – Sharon Seskin</p>
                </div>
                <div className="space-y-1 p-4 rounded-lg hover:bg-gray-50 transition-colors">
                  <p className="font-semibold text-lg text-[#182c78]">Mercia King</p>
                  <p className="text-sm text-gray-600">Travel Sales & Marketing Manager</p>
                </div>
              </div>

              {/* Team Photo */}
              <div className="w-full flex items-center justify-center">
                <div className="rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src={publicUrl('meet the team indoject.jpg')}
                    alt="IndoJet Travel team group photo"
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Reviews Section */}
      <div className="py-16 sm:py-20 bg-white">
        <div className="mx-auto max-w-5xl px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
              What They Say About Us
            </h2>
            <p className="text-gray-600 text-lg">
              Real words from the clients we proudly serve
            </p>
          </div>

          <div className="relative bg-gradient-to-br from-indojet-light/50 to-white rounded-3xl p-8 sm:p-10 shadow-xl overflow-hidden">
            {/* Decorative Elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#182c78]/5 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#14b8a6]/5 rounded-full -ml-24 -mb-24"></div>
            
            <div className="relative flex flex-col items-center text-center space-y-6">
              {/* Stars */}
              <div className="flex gap-1 text-yellow-400">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-6 w-6 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              
              {/* Client Info */}
              <div className="space-y-2">
                <h3 className="text-2xl sm:text-3xl font-bold text-[#182c78]">
                  {testimonials[testimonialIndex].name}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 font-medium">
                  {testimonials[testimonialIndex].title}
                </p>
              </div>
              
              {/* Quote */}
              <div className="relative max-w-4xl">
                <div className="absolute -left-8 -top-6 text-6xl text-[#182c78]/20 select-none font-serif">
                  "
                </div>
                <p className="text-gray-800 leading-relaxed text-base sm:text-lg italic relative z-10">
                  {testimonials[testimonialIndex].quote}
                </p>
              </div>
            </div>

            {/* Controls */}
            <div className="mt-10 flex items-center justify-center gap-3">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setTestimonialIndex(idx)}
                  className={clsx(
                    'h-3 rounded-full transition-all duration-300',
                    idx === testimonialIndex 
                      ? 'w-10 bg-[#182c78] shadow-md' 
                      : 'w-3 bg-gray-400/70 hover:bg-gray-500'
                  )}
                  aria-label={`Go to testimonial ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

